var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArchidektLogo = function SvgArchidektLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "archidekt_logo_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 635.85 149.53"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "archidekt_logo_svg__linear-gradient",
    x1: 79.01,
    y1: 122.7,
    x2: 107,
    y2: 74.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "archidekt_logo_svg__linear-gradient-2",
    x1: 29.95,
    y1: 37.65,
    x2: 85.94,
    y2: 37.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffa90a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f79c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "archidekt_logo_svg__linear-gradient-3",
    x1: 36.99,
    y1: 122.7,
    x2: 9,
    y2: 74.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("style", null, "@import url(https://fonts.googleapis.com/css?family=Strait);"))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      fill: "#333"
    },
    d: "M29.95 62.29v32.32l27.99 16.16 28-16.16V62.29l-28-16.16-27.99 16.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#archidekt_logo_svg__linear-gradient)",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 4
    },
    d: "m85.91 94.48-27.89 16.1 27.99 16.16L114 110.58V78.26L86.01 62.1l-.1 32.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#archidekt_logo_svg__linear-gradient-2)",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 4
    },
    d: "m58.04 45.79 27.9 16.1V29.57l-28-16.16-27.99 16.16v32.32l28.09-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#archidekt_logo_svg__linear-gradient-3)",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 4
    },
    d: "m30.09 94.48 27.89 16.1-27.99 16.16L2 110.58V78.26L29.99 62.1l.1 32.38z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.87 0 0 1 123.16 121.75)",
    style: {
      fontSize: "143.23px",
      fontFamily: "Strait-Regular,Strait"
    }
  }, "Archidekt "));
};

export { SvgArchidektLogo as ReactComponent };
export default "data:image/svg+xml;base64,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";